import request from '@/utils/request'

/**
 * 获取全部的评测问题及选项     
 * @param {*} form 
 */
export function getQuestionsAssess(form) {
	return request.post('/cust/assess', form);
}

/**
 * 传分数     
 * @param {*} form 
 */
export function postScore(form) {
	return request.post('/cust/assessresult', form);
}

/**
 * 请求签名地址
 * @param
 */
export function assessSign() {
	return request.post('/cust/assessSign');
}

/**
 * 
 * @returns 请求签名文件
 */
export function riskSignFile() {
	return request.post('/cust/riskSignFile');
} 

